import { useEffect, useState } from "react";
import PackButtonsExport from "./pack/packButtonsExport";
import { v4 as uuidv4 } from "uuid";
import PaginationAvantsolar from "components/utils/paginationAvantSolar";
import { useNavigate } from "react-router-dom";
import SpinnerAvantsolar from "components/utils/spinner";

const DataTableAvantSolar = ({
  data,
  dataCopy,
  setData,
  titleProps,
  headers, //Los nombres de las columnas que se van a imprimir en la tabla. //Los nombres de las columnas que se van a imprimir en los archivos de descarga.
  headersTable,
  name,
  properties,
  filtros,
  placeholderInput,
  defaultMostrar = 5,
  setUserPassword,
  toggleModal,
  loading,
  inputSearch = true,
  botonesFiltrado = true,
  exportButtons = true,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const [recordsPerPage, setRecordsPerPage] = useState();
  const nPages = Math.ceil(data?.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  let currentRecordSlice = data?.slice(indexOfFirstRecord, indexOfLastRecord);
  const [currentRecords, setCurrentRecords] = useState(currentRecordSlice);
  const [lastSort, setLastSort] = useState({ prop: "", mode: "" });
  const navigate = useNavigate();

  useEffect(() => {
    if (data) {
      let currentRecordSlice = data?.slice(
        indexOfFirstRecord,
        indexOfLastRecord
      );
      setCurrentRecords([...currentRecordSlice]);
    }
  }, [data, currentPage, recordsPerPage]);

  useEffect(() => {
    let mostrar = defaultMostrar == "Todos" ? data?.length : defaultMostrar;
    setRecordsPerPage(mostrar);
  }, [data]);

  useEffect(() => {
    const container = document.querySelector(".main-panel");
    container.scrollTop = 0;
  }, [currentRecords]);

  const orderTableColumn = (prop, mode) => {
    setLastSort({ prop, mode });
    let Sort = currentRecords.sort(function (a, b) {
      if (mode === "asc") {
        if (a[prop] < b[prop]) {
          return -1;
        }
        if (a[prop] > b[prop]) {
          return 1;
        }
        return 0;
      } else if (mode === "desc") {
        if (a[prop] > b[prop]) {
          return -1;
        }
        if (a[prop] < b[prop]) {
          return 1;
        }
        return 0;
      }
    });
    setCurrentRecords([...Sort]);
  };

  return (
    <div className="p-sm-5">
      <PackButtonsExport
        data={currentRecords}
        dataCopy={dataCopy}
        setData={setData}
        titleProps={titleProps + ` - ${new Date().toLocaleDateString()}`}
        headers={headers}
        name={name}
        properties={properties}
        filtros={filtros}
        placeholderInput={placeholderInput}
        setCurrentPage={setCurrentPage}
        inputSearch={inputSearch}
        exportButtons={exportButtons}
      ></PackButtonsExport>

      <div className="d-flex justify-content-center p-3 w-100 rounded mt-3">
        <table className=" table-responsive-xs w-100  tablaListado ">
          <thead className="">
            <tr className="text-center rounded ">
              {headersTable?.map((dato, i) => {
                return (
                  <th key={uuidv4()} className=" ">
                    <p>{dato.name}</p>
                    {botonesFiltrado && (
                      <div>
                        <span
                          onClick={() => orderTableColumn(dato.prop, "desc")}
                          className="m-0 pointer p-0 border-0 mdi mdi-menu-down"
                        ></span>
                        <span
                          onClick={() => orderTableColumn(dato.prop, "asc")}
                          className="m-0 pointer p-0 border-0 mdi mdi-menu-up"
                        ></span>
                      </div>
                    )}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {currentRecords?.map((objeto, i) => {
              return (
                <>
                  {objeto.nombreInstalacion && (
                    <>
                      <tr className="colorGrayLigth">
                        <td className="" colSpan={2}>
                          {objeto.nombreInstalacion.toUpperCase()}
                        </td>

                        <td
                          className="pointer"
                          onClick={() => {
                            navigate("/informacioncliente/" + objeto.usuario);
                          }}
                          colSpan={3}
                        >
                          {objeto.nombreTitular && objeto.nombreTitular}
                        </td>

                        <td colSpan={3}>
                          {objeto.datos[0].modulo && objeto.datos[0].modulo}
                        </td>
                      </tr>
                      {objeto.datos &&
                        objeto.datos.map((dato, i) => {
                          return (
                            <tr key={uuidv4()}>
                              {properties.map((element, i) => {
                                return (
                                  <td key={uuidv4()} className="text-center">
                                    {dato[element]}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                    </>
                  )}

                  {!objeto.datos && (
                    <tr
                      key={uuidv4()}
                      className={`${
                        i % 2 == 0 && !objeto.nombreInstalacion
                          ? "colorGrayLigth"
                          : ""
                      } text-center`}
                    >
                      {properties.map((element, i) => {
                        if (objeto.contrasena && i == "0")
                          return (
                            <td
                              key={uuidv4()}
                              className="pointer"
                              onClick={() => {
                                navigate(
                                  "/informacioncliente/" + objeto.usuario
                                );
                              }}
                            >
                              <p>{objeto[element]}</p>
                            </td>
                          );
                        if (element == "contraseña")
                          return (
                            <td
                              key={uuidv4()}
                              onClick={() => {
                                setUserPassword(objeto?.usuario);
                                toggleModal();
                              }}
                            >
                              <span
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content="Cambiar contraseña"
                                className="mdi mdi-key"
                              ></span>
                            </td>
                          );
                        return <td key={uuidv4()}>{objeto[element]}</td>;
                      })}
                    </tr>
                  )}
                </>
              );
            })}
          </tbody>
        </table>
      </div>
      {currentRecords?.length == 0 && !loading && dataCopy?.length > 0 && (
        <div className="d-flex justify-content-center my-3">
          <p className=" text-center alertTable colorGray  text-white p-2 rounded w-50">
            No hay registros con esta búsqueda
          </p>
        </div>
      )}
      {loading && <SpinnerAvantsolar></SpinnerAvantsolar>}
      <PaginationAvantsolar
        data={data}
        nPages={nPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setRecordsPerPage={setRecordsPerPage}
        recordsPerPage={recordsPerPage}
        defaultMostrar={defaultMostrar}
      ></PaginationAvantsolar>
    </div>
  );
};

export default DataTableAvantSolar;
